import { fg } from '@atlaskit/platform-feature-flags';
import {
	EDGE_REGION_HINT_HEADER,
	getEdgeRegionHint,
} from '@atlassian/search-common/get-edge-region-hint';

import type { BootstrapVariables } from '../../../common/constants/relay/types';

type getRelayFetchOptionsArgs = {
	primaryProduct: BootstrapVariables['primaryProduct'];
	productDataRegions: BootstrapVariables['productDataRegions'];
	cloudId?: BootstrapVariables['cloudId'];
};

export function getRelayFetchOptions({
	primaryProduct,
	productDataRegions,
	cloudId,
}: getRelayFetchOptionsArgs): {
	networkCacheConfig: {
		metadata: {
			headers: Record<string, string | undefined>;
		};
	};
} {
	const edgeRegionHint =
		primaryProduct && productDataRegions
			? getEdgeRegionHint(primaryProduct, productDataRegions)
			: undefined;

	return {
		networkCacheConfig: {
			metadata: {
				headers: {
					[EDGE_REGION_HINT_HEADER]: edgeRegionHint,
					...(cloudId && fg('rovo_fps_ms_teams_1p_picture_mapping')
						? { 'X-Query-Context': `ari:cloud:platform::site/${cloudId}` }
						: {}),
				},
			},
		},
	};
}
